// Português — Brasil
export default {
  translation: {
    app_name: 'Ledxo Hub',
    tagline: 'Onde hobbies constroem comunidades',
    nav_explore: 'Explorar',
    nav_find_folks: 'Encontrar pessoas',
    nav_sign_in: 'Entrar',
    nav_join_free: 'Entrar grátis',
    nav_sign_out: 'Sair',
    nav_my_profile: 'Meu perfil',
    nav_notifications: 'Notificações',
    auth_register: 'Criar conta',
    auth_login: 'Entrar',
    auth_name: 'Nome completo',
    auth_email: 'E-mail',
    auth_password: 'Senha',
    auth_age: 'Sua idade',
    auth_city: 'Cidade',
    auth_building: 'Condomínio / Edifício',
    auth_country: 'País',
    auth_currency: 'Moeda',
    auth_locale: 'Idioma e região',
    auth_already_have_account: 'Já tem uma conta?',
    auth_no_account: 'Não tem uma conta?',
    postcode_label: 'CEP',
    postcode_placeholder: 'ex. 01310-100',
    profile_edit: 'Editar perfil',
    profile_bio: 'Biografia',
    profile_interests: 'Interesses',
    profile_location: 'Localização',
    profile_theme: 'Tema',
    profile_currency_settings: 'Moeda e região',
    profile_save: 'Salvar alterações',
    profile_cancel: 'Cancelar',
    group_join: 'Entrar no grupo',
    group_leave: 'Sair do grupo',
    group_members: 'Membros',
    group_chat: 'Chat',
    group_events: 'Eventos',
    group_shop: 'Loja',
    group_campaigns: 'Campanhas',
    group_about: 'Sobre',
    group_full: 'Cheio',
    group_open: 'Aberto',
    tip_send: 'Enviar gorjeta',
    tip_amount: 'Valor',
    tip_message: 'Mensagem (opcional)',
    wallet_coins: 'moedas',
    wallet_balance: 'Saldo',
    tips_earned: 'ganhos',
    event_register: 'Inscrever-se',
    event_unregister: 'Cancelar inscrição',
    event_ticket_price: 'Ingresso',
    event_free: 'Gratuito',
    event_capacity: 'Capacidade',
    event_registered: 'inscrito(s)',
    no_results: 'Nenhum resultado encontrado',
    loading: 'Carregando…',
    error_generic: 'Algo deu errado. Por favor, tente novamente.',
  }
};
